"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import MyStreamWave from "../brain/my-stream/MyStreamWave";
import BrainContent from "../brain/content/BrainContent";
import { useAuth } from "../auth/Auth";
import useDeviceInfo from "../../hooks/useDeviceInfo";
import PrimaryButton from "../utils/button/PrimaryButton";
import useCreateModalState from "@/hooks/useCreateModalState";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
const WavesView: React.FC = () => {
  const $ = _c(12);
  const myStream = useMyStreamOptional();
  const {
    connectedProfile
  } = useAuth();
  const {
    isApp
  } = useDeviceInfo();
  const {
    openWave
  } = useCreateModalState();
  const serialisedWaveId = myStream?.activeWave.id ?? null;
  const showPlaceholder = !serialisedWaveId && !isApp;
  let content = null;
  if (serialisedWaveId) {
    const t0 = `wave-${serialisedWaveId}`;
    let t1;
    if ($[0] !== serialisedWaveId || $[1] !== t0) {
      t1 = <MyStreamWave key={t0} waveId={serialisedWaveId} />;
      $[0] = serialisedWaveId;
      $[1] = t0;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    content = t1;
  } else {
    if (showPlaceholder) {
      let t0;
      let t1;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <h2 className="tw-text-xl tw-font-bold tw-text-iron-50 tw-mb-4">Select a Wave</h2>;
        t1 = <p className="tw-text-iron-400 tw-max-w-md tw-mb-6 tw-text-sm sm:tw-text-base">Choose a wave to view its content and participate in the discussion.</p>;
        $[3] = t0;
        $[4] = t1;
      } else {
        t0 = $[3];
        t1 = $[4];
      }
      let t2;
      if ($[5] !== connectedProfile || $[6] !== openWave) {
        t2 = connectedProfile && <PrimaryButton onClicked={openWave} disabled={false} loading={false}><PlusIcon className="tw-w-5 tw-h-5 -tw-ml-1" />Create Wave</PrimaryButton>;
        $[5] = connectedProfile;
        $[6] = openWave;
        $[7] = t2;
      } else {
        t2 = $[7];
      }
      let t3;
      if ($[8] !== t2) {
        t3 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-text-center tw-p-8">{t0}{t1}{t2}</div>;
        $[8] = t2;
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      content = t3;
    }
  }
  let t0;
  if ($[10] !== content) {
    t0 = <BrainContent activeDrop={null} onCancelReplyQuote={_temp}>{content}</BrainContent>;
    $[10] = content;
    $[11] = t0;
  } else {
    t0 = $[11];
  }
  return t0;
};
export default React.memo(WavesView);
function _temp() {}